export default __webpack_public_path__ + "static/hackathon-cose-come-funziona-per-sviluppatori-astrorei-ac56bd1d785f228e8493373101469183.jpg";